<div
  
  style="
    width: 100vw;
    height: 100vh;
    position: absolute;
    background: url('{{this.background}}');
    z-index: 99999;
    background-size: cover;
    background-repeat: no-repeat;
  "
>
  <div
    class="row justify-content-center loader-header" style="
      font-family: Teko Regular;
      font-style: normal;
      font-weight: normal;
      font-size: 48px;
      color: white;
      position: absolute;
      width: 100%;
    "
  >
  cinejoy
  </div>
  <div
    class="row justify-content-center loader-spinner"
    style="position: absolute; width: 100%"
  >
    <img src="assets/images/cinejoy/loader.gif" style="width: 300px; height: 169px" />
  </div>
  <div
    class="row justify-content-center loader-text"
    style="
      position: absolute;
      width: 100%;
      font-family: Poppins Regular;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 27px;
      color: #ffffff;
    "
  >
    {{this.text}}
  </div>
</div>
